export const customerTypes = {
  LOCAL: 'LOCAL',
  ENTERPRISE: 'ENTERPRISE',
  NATIONAL: 'NATIONAL',
  REGIONAL: 'REGIONAL'
};

export const customerTypesLabels = {
  LOCAL: 'Local',
  ENTERPRISE: 'Enterprise',
  NATIONAL: 'National',
  REGIONAL: 'Regional'
};

export const customerTypesOptions = [
  {
    id: customerTypes.LOCAL,
    label: customerTypesLabels.LOCAL
  },
  {
    id: customerTypes.ENTERPRISE,
    label: customerTypesLabels.ENTERPRISE
  },
  {
    id: customerTypes.NATIONAL,
    label: customerTypesLabels.NATIONAL
  },
  {
    id: customerTypes.REGIONAL,
    label: customerTypesLabels.REGIONAL
  }
];

export const paymentMethodTypes = {
  CARD: 'cc',
  INVOICE: 'invoice',
  ACH: 'ach'
};
